import React from "react";
import { Box, Typography } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import UserMessage from "./UserMessage";
import BotMessage from "./BotMessage";
import {
  mobileNavMediaQuery,
  narrowChatSurfaceSx,
} from "../../../layout/layoutMetrics";

const DESKTOP_MESSAGE_PADDING_X = 28;

export default function MessagesContainer({
  messages,
  copiedMessageId,
  setCopiedMessageId,
  handleDownload,
  onViewGeneratedVideo,
  messagesEndRef,
}) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        height: "100%",
        boxSizing: "border-box",
        minHeight: 0,
        overflowY: "auto",
        py: 2,
        display: "flex",
        flexDirection: "column",
        gap: 5,
        px: DESKTOP_MESSAGE_PADDING_X,
        [`@media ${mobileNavMediaQuery}`]: {
          ...narrowChatSurfaceSx,
          gap: 3.5,
        },
      }}
    >
      {messages.length === 0 && (
        <Box
          sx={{
            flexGrow: 1,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            opacity: 0.4,
          }}
        >
          <AutoAwesomeIcon sx={{ fontSize: 50, mb: 2 }} />
          <Typography variant="h6">What can I create for you today?</Typography>
          <Typography sx={{ mt: 1, fontSize: 16 }}>
            Start with an image, video, or content prompt.
          </Typography>
        </Box>
      )}

      {messages.map((msg, index) =>
        msg.type === "user" ? (
          <UserMessage key={index} msg={msg} />
        ) : (
          <BotMessage
            key={index}
            msg={msg}
            index={index}
            copiedMessageId={copiedMessageId}
            setCopiedMessageId={setCopiedMessageId}
            handleDownload={handleDownload}
            onViewGeneratedVideo={onViewGeneratedVideo}
          />
        ),
      )}

      <div ref={messagesEndRef} />
    </Box>
  );
}